const ACCOMODATION_SEARCH = {
  ACCOMODATION_ROOT_LANGUAGES: 'ACCOMODATION_ROOT_LANGUAGES',
  ACCOMODATION_ROOT_LOCATIONS: 'ACCOMODATION_ROOT_LOCATIONS',

  ACCOMODATION_SEARCH_DROPDOWN_VALUES: 'ACCOMODATION_SEARCH_DROPDOWN_VALUES',
  ACCOMODATION_SEARCH_DAY_BEFORE_OR_AFTER: 'ACCOMODATION_SEARCH_DAY_BEFORE_OR_AFTER',
};

export default ACCOMODATION_SEARCH;
